"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.TITLE_CLASS = exports.NODE_LABEL_CLASS = exports.INERT_NODE_TYPES = exports.BACK_LINK_CLASS = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ChevronRight = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronRight"));
var _ChevronLeft = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronLeft"));
var _EDSContext = require("../EDSContext/EDSContext");
var _Paper = _interopRequireDefault(require("../Paper"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _TreeView = _interopRequireDefault(require("./internal/TreeView"));
var _TreeItem = _interopRequireDefault(require("./internal/TreeItem"));
var _findItemByNodeId = _interopRequireDefault(require("./findItemByNodeId"));
var _Button = _interopRequireDefault(require("../Button"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _makeStylesInternal = _interopRequireDefault(require("../makeStyles/makeStylesInternal"));
var _useTextOverflow3 = _interopRequireDefault(require("./internal/useTextOverflow"));
var _MasterDetailBreadcrumbs = _interopRequireDefault(require("./internal/MasterDetailBreadcrumbs"));
var _tokens = require("../styles/tokens");
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _initial = _interopRequireDefault(require("lodash/initial"));
var _difference = _interopRequireDefault(require("lodash/difference"));
var _last = _interopRequireDefault(require("lodash/last"));
var _excluded = ["children", "menu", "title", "TitleTypographyProps", "onNodeSelect", "edsContext", "variant", "detailTitle", "selectedNodeId", "showDetailBreadcrumbs"],
  _excluded2 = ["label", "nodeId", "children"],
  _excluded3 = ["label", "nodeId", "children", "type"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStylesInternal.default)(function (theme) {
  return {
    root: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    inline: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
      borderRadius: _tokens.spacing30
    },
    sideMenuRoot: {
      borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
      display: 'flex',
      flexDirection: 'column',
      width: 'auto',
      padding: _tokens.spacingInsetShort40,
      backgroundColor: theme.palette.background.default,
      '& $iconContainer': {
        marginLeft: 0
      }
    },
    iconContainer: {},
    sideMenuRootInline: {
      borderTopLeftRadius: _tokens.spacing30,
      borderBottomLeftRadius: _tokens.spacing30
    },
    sideTitle: {
      fontWeight: '600',
      color: theme.palette.action.base,
      maxWidth: '18rem'
    },
    sideMenuTreeViewContainer: {
      overflowY: 'auto',
      overflowX: 'hidden',
      width: '18.75rem'
    },
    sideMenuTreeView: {},
    contentRoot: {
      padding: _tokens.spacing60,
      width: '100%',
      height: '100%',
      overflowY: 'auto'
    },
    label: {
      display: 'grid',
      fontSize: _tokens.fontSizeDefault,
      alignItems: 'center',
      justifyContent: 'space-between',
      gridAutoFlow: 'column',
      gridGap: _tokens.spacing30
    },
    pill: {
      borderRadius: _tokens.borderRadiusMedium,
      backgroundColor: theme.palette.grey[500],
      opacity: '.7',
      color: theme.palette.grey[100],
      fontSize: _tokens.fontSizeSmall,
      minWidth: '1.25rem',
      height: '1.25rem',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'inline-flex',
      paddingRight: _tokens.spacing30,
      paddingLeft: _tokens.spacing30
    },
    transparentPill: {
      color: 'transparent',
      backgroundColor: 'transparent'
    },
    firstLevelHighlightBar: {
      display: 'inline-flex',
      height: _tokens.sizingXLarge,
      width: 0
    },
    chevron: {
      fill: theme.palette.grey[400],
      transition: "transform " + _tokens.durationFastAlt + " cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      marginRight: '.2rem'
    },
    expanded: {
      '& $pill': {
        backgroundColor: theme.palette.action.base,
        opacity: 1
      },
      '& $transparentPill': {
        color: 'transparent',
        backgroundColor: 'transparent'
      }
    },
    secondLevelSelected: {
      '& $label': {
        fontWeight: '600'
      }
    },
    levelTwoSelected: {},
    levelTwoExpanded: {},
    bold: {
      fontWeight: 'bold',
      color: theme.palette.grey[500]
    },
    expandedFirstLevel: {
      '&$selectedFirstLevel': {
        color: theme.palette.grey[600]
      },
      '& $chevron': {
        fill: theme.palette.grey[600],
        transform: 'rotate(90deg)'
      }
    },
    selectedFirstLevel: {
      '& $bold': {
        color: theme.palette.grey[600],
        fontWeight: 'bold'
      },
      '& $firstLevelHighlightBar': {
        borderLeft: _tokens.borderWidthThicker + " solid " + theme.palette.action.base
      }
    },
    preventEvents: {
      pointerEvents: 'none'
    },
    sectionHeader: {
      textTransform: 'uppercase'
    },
    dividerRoot: {
      // `classes.root` is not increasing the specificity,
      // so this is the workaround to fix that.
      '&$divider': {
        marginTop: _tokens.spacing30,
        marginBottom: _tokens.spacing30
      }
    },
    divider: {},
    thirdLevelMarker: {
      display: 'inline-flex',
      height: _tokens.sizingXLarge,
      width: 0,
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
    },
    thirdLevelHighlightBar: {},
    thirdLevelSelected: {
      color: theme.palette.action.active,
      '& $thirdLevelHighlightBar': {
        border: _tokens.borderWidthThin + " solid " + theme.palette.action.base
      }
    },
    backLink: {
      marginLeft: "-" + _tokens.spacing40,
      marginRight: "-" + _tokens.spacing40,
      '& a': {
        display: 'inherit',
        maxWidth: '20rem'
      }
    },
    ellipsis: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    displayInherit: {
      display: 'inherit',
      // To show ellipsis
      marginRight: _tokens.spacing50
    },
    title: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  };
});
var NODE_LABEL_CLASS = exports.NODE_LABEL_CLASS = 'eds-node-label';
var TITLE_CLASS = exports.TITLE_CLASS = 'eds-title-text';
var BACK_LINK_CLASS = exports.BACK_LINK_CLASS = 'eds-backlink-text';
var INERT_NODE_TYPES = exports.INERT_NODE_TYPES = ['divider', 'sectionHeader'];

/**
 * Returns the path to the given nodeId, in the form of an array of
 * menu items. Array includes the node corresponding to the nodeId
 *
 * @param {Array.<object>} menu The menu tree
 * @param {string}         nodeId The node to search for
 * @return {Array.object}  The path to the node, as a list of menu items. Empty
 *                         array if nodeId not found.
 */
var getPath = function getPath(menu, nodeId) {
  var traverse = function traverse(subtree, currentPath) {
    for (var i = 0; i < subtree.length; i++) {
      var item = subtree[i];
      if (item.nodeId === nodeId) {
        return [].concat(currentPath, [item]);
      } else if ((0, _isArray.default)(item.children)) {
        var childPath = traverse(item.children, [].concat(currentPath, [item]));
        if (!(0, _isEqual.default)(childPath, currentPath)) {
          return childPath;
        }
      }
    }
    return (0, _initial.default)(currentPath);
  };
  var currentPath = traverse(menu, []);
  return currentPath;
};

/**
 * Build the current pane in the master view
 *
 * @param {object}        menu           The full menu hierarchy
 * @param {string}        selectedNodeId The id of the currently-selected node
 * @param {string}        rootTitle      The title of the root pane
 * @return {Array.object} An array of panes objects, representing the the panes
 *                        leading down to the selected node.
 */
var buildPanes = function buildPanes(menu, selectedNodeId, rootTitle) {
  var _path;
  var path = getPath(menu, selectedNodeId);

  // figure out which pane the selected node is on
  var numPanes = Math.ceil(path.length / 3);

  // if the currently-selected node is (a) the terminal node is the current pane; and (b) has
  // children, then we need to display the *next* pane
  if (path.length % 3 === 0 && (_path = path[path.length - 1]) != null && _path.children) {
    numPanes++;
  }
  var localMultiPanes = [];

  // start with the root pane
  localMultiPanes.push({
    menuItems: menu,
    menuTitle: rootTitle,
    prevPaneLinkText: ''
  });

  // render all panes down to the current one
  for (var i = 1; i < numPanes; i++) {
    var childNode = path[i * 3 - 1];
    var previousMenuItem = path[i * 3 - 2];
    localMultiPanes.push({
      selectedMenuItem: childNode,
      previousMenuItem: previousMenuItem,
      menuItems: childNode.children,
      menuTitle: childNode.label,
      prevPaneLinkText: localMultiPanes[i - 1].menuTitle
    });
  }
  return localMultiPanes;
};

/**
 * A split pane view of a parent-child relationship.
 * When you click the item in the **master** list,
 * then you can see the **details** of the item in the **detail** view.
 * The master list can show multiple levels inside of a tree structure.
 * @done true
 * @updated v7.11.0
 * @versionAdded v5.1.0
 * @template true
 * @examples
 *  MasterDetailExample
 *  MultiLevelNavigationExample
 *  MasterDetailOnCard
 *  MasterDetailOnDialog
 */
var MasterDetail = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _cn5, _cn6;
  var children = props.children,
    menu = props.menu,
    title = props.title,
    TitleTypographyProps = props.TitleTypographyProps,
    onNodeSelect = props.onNodeSelect,
    edsContext = props.edsContext,
    variant = props.variant,
    detailTitle = props.detailTitle,
    selectedNodeId = props.selectedNodeId,
    showDetailBreadcrumbs = props.showDetailBreadcrumbs,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var localClasses = useStyles();
  var _useState = (0, _react.useState)([]),
    expandedNodes = _useState[0],
    setExpandedNodes = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    selectedPath = _useState2[0],
    setSelectedPath = _useState2[1];
  var _useState3 = (0, _react.useState)([{
      menuItems: menu,
      menuTitle: title,
      prevPaneLinkText: ''
    }]),
    multiPanes = _useState3[0],
    setMultiPanes = _useState3[1];
  var timeStamp = new Date().getMilliseconds();
  var titleRef = (0, _react.useRef)(null);
  var backLinkRef = (0, _react.useRef)(null);
  var treeViewRef = (0, _react.useRef)(null);
  var _useTextOverflow = (0, _useTextOverflow3.default)(titleRef, "." + TITLE_CLASS + "-" + timeStamp),
    titleOverflow = _useTextOverflow[0],
    setTitleOverflow = _useTextOverflow[1];
  var _useTextOverflow2 = (0, _useTextOverflow3.default)(backLinkRef, "." + BACK_LINK_CLASS + "-" + timeStamp),
    backLinkOverflow = _useTextOverflow2[0],
    setBackLinkOverflow = _useTextOverflow2[1];

  // invoked on click, space key, and enter key of a non-parent (expandable) node
  var onNodeClicked = function onNodeClicked(event, nodeIds) {
    var selectedItem = (0, _findItemByNodeId.default)(menu, nodeIds);
    onNodeSelect && onNodeSelect(event, selectedItem);
    treeViewRef.current.setAttribute('data-manual-expansion', 'true');
  };

  // invoked on a parent (expandable) node, on click or enter key
  var onNodeToggle = function onNodeToggle(event, nodeIds) {
    var expandedNode;

    // look at the difference between the previous list of expanded nodes and the
    // new list of expanded nodes, to determine which one was just expanded
    if (nodeIds.length > expandedNodes.length) {
      expandedNode = (0, _difference.default)(nodeIds, expandedNodes);
      // const path = getPath(menu, focusedNode);
      var path = getPath(menu, expandedNode[0]);

      // handle movement to a new pane (if necessary)
      handlePaneNavigation(path, expandedNode[0], multiPanes);
    }

    // set the new expansion state
    setExpandedNodes(nodeIds);
  };
  var onBackToPaneClicked = function onBackToPaneClicked(e) {
    // go back to the previous pane
    var newPanes = multiPanes.slice(0, -1);
    setMultiPanes(newPanes);
    setBackLinkOverflow(false);
    setTitleOverflow(false);

    // move up to the previous node in the hierarchy
    onNodeSelect(e, (0, _last.default)(multiPanes).previousMenuItem);
  };
  var onBreadcrumbClicked = function onBreadcrumbClicked(e, selectedMenuItem) {
    // move up to the previous node in the hierarchy
    onNodeSelect(e, selectedMenuItem);
    var path = getPath(menu, selectedNodeId);
    handlePaneNavigation(path, selectedNodeId, multiPanes);
  };

  /**
   * Determines whether we need to move to a new pane in the nav tree.
   */
  var handlePaneNavigation = (0, _react.useCallback)(function (path, nodeId, multiPanesLocal) {
    // figure out which pane the current path is in
    var paneNumber = Math.ceil(path.length / 3);

    // if this is the terminal node for this pane, and it has children, we
    // display the next pane
    if (path.length > 0 && path.length % 3 === 0 && !(0, _isEmpty.default)((0, _last.default)(path).children)) {
      paneNumber += 1;
    }

    // if we're switching panes ...
    if (paneNumber !== multiPanesLocal.length) {
      setMultiPanes(buildPanes(menu, nodeId, title));
      setBackLinkOverflow(false);
      setTitleOverflow(false);
    }
  }, [menu, setBackLinkOverflow, setTitleOverflow, title]);

  // update the our internal record of the current selection path
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(selectedNodeId)) {
      var path = getPath(menu, selectedNodeId);

      // if we're on a different node
      if (!(0, _isEqual.default)(path, selectedPath)) {
        // set the new path
        setSelectedPath(path);

        // check if we need new panes
        handlePaneNavigation(path, selectedNodeId, multiPanes);
      }
      if (treeViewRef.current.dataset.manualExpansion !== 'true') {
        setExpandedNodes(path.map(function (node) {
          return node.nodeId;
        }));
      }
    }

    // if this node has a manual expansion marker, clear it
    if (treeViewRef.current.dataset.manualExpansion === 'true') {
      treeViewRef.current.removeAttribute('data-manual-expansion');
    }
  }, [menu, selectedNodeId, handlePaneNavigation, multiPanes, selectedPath]);

  // This effect is required to update the state if a menu is modified after the component is mounted.
  (0, _react.useEffect)(function () {
    setMultiPanes([{
      menuItems: menu,
      menuTitle: title,
      prevPaneLinkText: ''
    }]);
    setSelectedPath([]);
  }, [menu, title]);

  /**
   * Returns the title to use for the detail section
   *
   * @return {string} The title to use. Null if no title is avaialable.
   */
  var getDetailTitle = function getDetailTitle() {
    var localDetailTitle = null;

    // if we're instructed to use the node label as page title
    if ((0, _isBoolean.default)(detailTitle) && detailTitle) {
      var pageItem = (0, _last.default)(selectedPath);
      localDetailTitle = pageItem !== undefined ? pageItem.label : null;

      // if we were given an explicit title to use
    } else if ((0, _isString.default)(detailTitle)) {
      localDetailTitle = detailTitle;
    }
    return localDetailTitle;
  };

  // Similar to this: https://material-ui.com/components/tree-view/#rich-object
  var generateMenu = function generateMenu() {
    var generateChildren = function generateChildren(items, level) {
      var treeItems = items.length > 0 && items.map(function (_ref) {
        var _cn, _cn2, _cn3;
        var label = _ref.label,
          nodeId = _ref.nodeId,
          childrenProp = _ref.children,
          itemRest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded2);
        // Don't render the tree at level 4.
        // The contents after level 4 are going to be rendered in another pane.
        // Also this saves us some time to render the whole tree which is efficient.
        if (level === 4) {
          return /*#__PURE__*/_react.default.createElement("span", {
            key: "level-4-placeholder-" + nodeId + "-" + label
          }); // Returning `null` crashes the page
        }
        var labelWithPill = /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(localClasses.label, (_cn = {}, _cn[localClasses.levelTwoExpanded] = level === 2, _cn[localClasses.levelTwoSelected] = level === 2, _cn))
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(localClasses.ellipsis, NODE_LABEL_CLASS)
        }, label), level === 2 && childrenProp && /*#__PURE__*/_react.default.createElement("span", {
          className: localClasses.pill
        }, childrenProp.length), level === 3 && childrenProp && /*#__PURE__*/_react.default.createElement("span", null, edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, null) : /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null)), level === 3 && !childrenProp && /*#__PURE__*/_react.default.createElement("span", {
          className: (0, _classnames.default)(localClasses.pill, localClasses.transparentPill)
        }));
        return /*#__PURE__*/_react.default.createElement(_TreeItem.default, (0, _extends2.default)({
          key: nodeId + "-" + label,
          label: labelWithPill,
          tooltipText: label // Not exposed, only for internal use
          ,
          "data-nodeid": nodeId,
          "data-level": level,
          icon: /*#__PURE__*/_react.default.createElement("span", {
            className: (0, _classnames.default)(localClasses.thirdLevelHighlightBar, (_cn2 = {}, _cn2[localClasses.thirdLevelMarker] = level === 3, _cn2))
          }),
          nodeId: nodeId,
          className: (0, _classnames.default)((_cn3 = {}, _cn3[localClasses.leftBorder] = level === 3, _cn3)),
          classes: {
            expanded: localClasses.expanded,
            selected: level === 2 && localClasses.secondLevelSelected || level === 3 && localClasses.thirdLevelSelected
          }
        }, itemRest), childrenProp && generateChildren(childrenProp, level + 1));
      });
      return treeItems;
    };
    return /*#__PURE__*/_react.default.createElement(_TreeView.default, {
      onNodeSelect: onNodeClicked,
      onNodeToggle: onNodeToggle,
      className: localClasses.sideMenuTreeView,
      expanded: expandedNodes,
      selected: selectedNodeId
    }, currentPane.menuItems.map(function (child) {
      var _cn4;
      var label = child.label,
        nodeId = child.nodeId,
        childrenProp = child.children,
        type = child.type,
        childProps = (0, _objectWithoutPropertiesLoose2.default)(child, _excluded3);
      var newLabel = childrenProp ? /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(localClasses.label, localClasses.bold)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(localClasses.ellipsis, NODE_LABEL_CLASS)
      }, label), edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, {
        className: localClasses.chevron
      }) : /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
        className: localClasses.chevron
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(localClasses.label, localClasses.bold, localClasses.ellipsis, localClasses.displayInherit,
        // To show ellipsis, without this it won't work
        NODE_LABEL_CLASS)
      }, label);
      if (type === 'divider') {
        newLabel = /*#__PURE__*/_react.default.createElement(_Divider.default, {
          className: localClasses.dividerRoot,
          classes: {
            root: localClasses.divider
          }
        });
      } else if (type === 'sectionHeader') {
        newLabel = /*#__PURE__*/_react.default.createElement(_Typography.default, {
          className: (0, _classnames.default)(localClasses.sectionHeader, localClasses.ellipsis, NODE_LABEL_CLASS)
        }, label);
      }
      return /*#__PURE__*/_react.default.createElement(_TreeItem.default, (0, _extends2.default)({
        key: nodeId + "-" + label,
        label: newLabel,
        tooltipText: label // Not exposed, only for internal use
        ,
        nodeId: nodeId,
        classes: {
          expanded: !INERT_NODE_TYPES.includes(type) ? localClasses.expandedFirstLevel : '',
          selected: !INERT_NODE_TYPES.includes(type) ? localClasses.selectedFirstLevel : '',
          iconContainer: localClasses.iconContainer
        },
        icon: /*#__PURE__*/_react.default.createElement("span", {
          className: localClasses.firstLevelHighlightBar
        }),
        "data-nodeid": nodeId,
        "data-level": 1,
        disabled: type === 'divider' || type === 'sectionHeader',
        className: (0, _classnames.default)((_cn4 = {}, _cn4[localClasses.preventEvents] = INERT_NODE_TYPES.includes(type), _cn4))
      }, childProps, {
        // note: adding an explicit tab index here to get around an issue in tree view
        //
        // when switching to a new pane, we render a subset of the tree (ie, only the portion
        // appearing in that pane). MUI TreeView's internal keyboard logic depends on each
        // node having an explicit parent — which they do *not* in child panes, at the top
        // level, because of the way we render subtrees in panes
        //
        // this resulted in keyboard navigation not working after moving into a child pane (the
        // user needed to click into a node to reset TreeView keyboard nav)
        //
        // this explicit tab index ensures that the top-level node is always keyboard navigable,
        // regardless of TreeView's internal nav logic
        tabIndex: "0"
      }), childrenProp && generateChildren(childrenProp, 2));
    }));
  };
  var currentPane = multiPanes.slice(-1)[0];
  var prevPaneLinkText = currentPane.prevPaneLinkText;
  var menuTitle = currentPane.menuTitle;
  var backToLinkLabel = edsContext.formatMessage('component.MasterDetail.backToLinkLabel', {
    label: prevPaneLinkText
  });
  var displayedTitle = getDetailTitle();
  return /*#__PURE__*/_react.default.createElement(_Paper.default, (0, _extends2.default)({
    ref: ref,
    className: (0, _classnames.default)(localClasses.root, (_cn5 = {}, _cn5[localClasses.inline] = variant === 'inline', _cn5)),
    elevation: 0
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "master",
    className: (0, _classnames.default)(localClasses.sideMenuRoot, (_cn6 = {}, _cn6[localClasses.sideMenuRootInline] = variant === 'inline', _cn6))
  }, prevPaneLinkText && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h4",
    className: localClasses.backLink
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: localClasses.ellipsis,
    variant: "text",
    onClick: onBackToPaneClicked,
    startIcon: edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null) : /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, null),
    ref: backLinkRef
  }, backLinkOverflow ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: backToLinkLabel
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(localClasses.ellipsis, BACK_LINK_CLASS + "-" + timeStamp)
  }, backToLinkLabel)) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(localClasses.ellipsis, BACK_LINK_CLASS + "-" + timeStamp)
  }, backToLinkLabel)), /*#__PURE__*/_react.default.createElement(_Divider.default, null)), /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    component: "div",
    className: (0, _classnames.default)(localClasses.sideTitle, localClasses.sectionHeader),
    ref: titleRef,
    gutterBottom: true
  }, TitleTypographyProps), titleOverflow ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: menuTitle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(localClasses.ellipsis, TITLE_CLASS + "-" + timeStamp)
  }, menuTitle)) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(localClasses.ellipsis, TITLE_CLASS + "-" + timeStamp)
  }, menuTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: localClasses.sideMenuTreeViewContainer,
    ref: treeViewRef,
    tabIndex: "-1"
  }, generateMenu())), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "detail",
    className: localClasses.contentRoot
  }, showDetailBreadcrumbs && /*#__PURE__*/_react.default.createElement(_MasterDetailBreadcrumbs.default, {
    selectedPath: selectedPath,
    rootTitle: title,
    onNodeSelect: onBreadcrumbClicked
  }), displayedTitle && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: localClasses.title,
    variant: "h1"
  }, displayedTitle)), children));
});
MasterDetail.muiName = 'MasterDetail';
MasterDetail.displayName = 'MasterDetail';
MasterDetail.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The content of the detail view.
   */
  children: _propTypes.default.node,
  /**
   * The title of the master view.
   */
  title: _propTypes.default.string,
  /**
   * Props applied to the `Typography` element of the `title` prop.
   */
  TitleTypographyProps: _propTypes.default.object,
  /**
   * The structure and content of the master tree.
   *
   * Accepts an array of objects, one for each node in the tree. Object format:
   *
   * * `label`: {string} (required) The node label.
   * * `nodeId`: {string} (required) The id of the node. Provided to `onNodeSelect` when the node is selected.
   * * `onClick`: {function} Callback that's invoked when the node is clicked.
   * * `children`: {array} The children of this node. Accepts an array with the same structure as the parent `menu`.
   * * `type`: {string} Non-interactive node. The value can be `divider` or `sectionHeader`. For `divider` type, you can omit `label.
   */
  menu: _propTypes.default.array,
  /**
   * A node id representing the currently-selected item. This is a required prop. Use empty string if there
   * is no current selection.
   */
  selectedNodeId: _propTypes.default.string.isRequired,
  /**
   * Callback fired when tree items are selected/unselected.
   *
   * `@param {object} event`: The event source of the callback
   *
   * `@param {object} item`: The menu item of the selected node
   */
  onNodeSelect: _propTypes.default.func,
  /**
   * Style variant of the MasterDetail to be displayed.
   * `inline` variant will have border around this component.
   */
  variant: _propTypes.default.oneOf(['inline', 'page']),
  /**
   * Whether to show breadcrumbs at the top of the detail section.
   */
  showDetailBreadcrumbs: _propTypes.default.bool,
  /**
   * Whether to show a title at the top of the detail section.
   *
   * There are several options:
   *
   * * Boolean: If `true`, the title will be the set to the label of the node selected in the Master view.\
   * * String: The title will be set to the given value
   *
   */
  detailTitle: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object
};
MasterDetail.defaultProps = {
  variant: 'page',
  detailTitle: true,
  showDetailBreadcrumbs: true,
  selectedNodeId: ''
};
var _default = exports.default = (0, _EDSContext.withEDSContext)(MasterDetail);